import React from 'react';

import { useDispatch } from 'react-redux';

import PaginationWithDropdown from 'src/components/shared/paginationWithDropdown/paginationWithDropdown';
import { setCurrentPage, setPerPage } from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import { useAppSelector } from 'src/store/store';

/**
 * Default Component.
 */
const RestrictionFormPagination = () => {
  const dispatch = useDispatch();
  const { currentPage, totalPages, perPage } = useAppSelector((state) => state.regionTasksConfigPage);

  return (
    <PaginationWithDropdown
      currentPage={currentPage}
      totalPages={totalPages}
      perPage={perPage}
      setPerPage={(newPerPage) => dispatch(setPerPage(newPerPage))}
      setCurrentPage={(newPage) => dispatch(setCurrentPage(newPage))}
    />
  );
};

export default RestrictionFormPagination;
